import React from 'react';
import CouponIcon from '../../../components/icons/general/CouponIcon';

interface CouponInputProps {
  couponInput: string;
  setCouponInput: (value: string) => void;
  couponApplied: boolean;
  showRemovedMessage: boolean;
  couponError?: string;
  isLoading?: boolean;
  onApplyCoupon: () => void;
}

export const CouponInput: React.FC<CouponInputProps> = ({
  couponInput,
  setCouponInput,
  couponApplied,
  showRemovedMessage,
  couponError,
  isLoading = false,
  onApplyCoupon,
}) => {
  return (
    <div className="relative">
      <div className="flex">
        <div className="relative flex-grow">
          <input
            type="text"
            id="coupon"
            value={couponInput}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onApplyCoupon();
              }
            }}
            // Código entra sempre MAIÚSCULO e SEM espaços (igual à normalização do backend)
            onChange={(e) => setCouponInput(e.target.value.replace(/\s+/g, '').toUpperCase())}
            placeholder="CUPOMXYZ"
            className={`w-full pl-10 pr-3 py-2 border rounded-l-md focus:ring-primary focus:border-primary text-sm bg-input-bg-light dark:bg-input-bg-dark text-text-primary dark:text-gray-200 placeholder-gray-400 dark:placeholder-gray-500 ${
              couponError ? 'border-red-500' : 'border-medium-gray dark:border-gray-600'
            }`}
            disabled={couponApplied && !showRemovedMessage}
            aria-label="Código do cupom"
          />
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <CouponIcon />
          </div>
        </div>
        <button
          onClick={onApplyCoupon}
          disabled={(couponApplied && !showRemovedMessage) || !couponInput || isLoading}
          className="basis-auto w-fit bg-dark-gray hover:bg-gray-800 dark:bg-gray-600 dark:hover:bg-gray-500 text-white px-4 py-2 rounded-r-md focus:outline-none focus:ring-2 focus:ring-dark-gray dark:focus:ring-gray-500 focus:ring-offset-1 text-sm font-semibold disabled:opacity-50 transition-colors flex items-center"
        >
          {isLoading ? (
            <>
              <svg className="animate-spin -ml-1 mr-2 h-3 w-3 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              APLICANDO...
            </>
          ) : (
            couponApplied && !showRemovedMessage ? 'APLICADO' : 'ADICIONAR'
          )}
        </button>
      </div>
    </div>
  );
}; 